import { render, staticRenderFns } from "./NewsletterSendAdmin.vue?vue&type=template&id=8351ffa4&scoped=true&"
import script from "./NewsletterSendAdmin.vue?vue&type=script&lang=js&"
export * from "./NewsletterSendAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSendAdmin.vue?vue&type=style&index=0&id=8351ffa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8351ffa4",
  null
  
)

export default component.exports